import React, { createContext, useContext, useRef } from "react"

type MobileNavContextValue = {
	newChatDrawerOpenerRef: React.MutableRefObject<(() => void) | null>
}

const MobileNavContext = createContext<MobileNavContextValue>({} as MobileNavContextValue)

export const MobileNavProvider: React.FC = ({ children }) => {
	const newChatDrawerOpenerRef = useRef<(() => void) | null>(null)

	return (
		<MobileNavContext.Provider value={{ newChatDrawerOpenerRef }}>
			{children}
		</MobileNavContext.Provider>
	)
}

export const useMobileNav = (): MobileNavContextValue => useContext(MobileNavContext)
